import React, { useState, useRef } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Button, Typography, TextField } from "@mui/material";
import logoImage from "../../../assets/images/logoblue.png";
import { ResetPassword } from "../components";

function CodeForgotPassword() {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [codes, setCodes] = useState(["", "", "", "", "", ""]);
  const inputRefs = [
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ];

  const handleCodeChange = (index, value) => {
    const newCodes = [...codes];
    newCodes[index] = value;
    setCodes(newCodes);

    // Move focus to the next input field if available
    if (value && index < 5) {
      inputRefs[index + 1].current.focus();
    }

    // Move focus to the previous input field if available
    if (!value && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   setShowResetPassword(true);
  //   const code = codes.join("");
  //   console.log("Code:", code);
  // };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Check if the entered code matches "123456"
    const enteredCode = codes.join("");
    if (enteredCode === "123456") {
      // Redirect the user to the ResetPassword component if the code is correct
      setShowResetPassword(true);
    } else {
      // Show an error message if the code is incorrect
      alert("Incorrect verification code. Please try again.");
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CssBaseline />
        {showResetPassword ? (
          <ResetPassword />
        ) : (
          <Grid
            container
            direction="column"
            alignItems="center"
            spacing={2}
            maxWidth="336px"
          >
            <Grid item>
              <img
                src={logoImage}
                alt="Logo"
                style={{ width: "335.99px", height: "86px", color: "#00A7CD" }}
              />
            </Grid>
            <Grid
              item
              display={"flex"}
              flexDirection="column"
              gap={"4px"}
              spacing={2}
              width="100%"
            >
              <Typography variant="h6" fontWeight={700}>
                Forgot Password
              </Typography>
              <Typography
                fontSize={"14px"}
                fontWeight={500}
                lineHeight={"20px"}
              >
                Please enter the code that was sent to your e-mail address
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "5px",
                  paddingTop: "10px",
                }}
              >
                {codes.map((code, index) => (
                  <TextField
                    key={index}
                    inputRef={inputRefs[index]}
                    type="text"
                    value={code}
                    onChange={(e) => handleCodeChange(index, e.target.value)}
                    variant="outlined"
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        width: "45px",
                        height: "40px",
                        borderRadius: "8px",
                        border: "2px solid #00A7CD",
                        fontSize: "48px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        letterSpacing: "-0.15px",
                      },
                    }}
                  />
                ))}
              </div>
            </Grid>

            <Grid item width={"336px"} paddingTop={"24px"}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                style={{
                  width: "100%",
                  height: "34px",
                  borderRadius: "4px",
                  backgroundColor: "#00A7CD",
                }}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
}

export default CodeForgotPassword;
